import React, { useState, useMemo } from "react";

function DataTablePagination({ currentPage, totalPages, onPageChange }) {
  const [leftHover, setLeftHover] = useState(false);
  const [rightHover, setRightHover] = useState(false);

  // --- 1. HOOKS ALWAYS GO AT THE TOP ---
  const visiblePages = useMemo(() => {
    const maxVisible = 4;

    if (totalPages <= maxVisible) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    if (startPage <= 1) {
      startPage = 1;
      endPage = maxVisible;
    }

    if (endPage >= totalPages) {
      endPage = totalPages;
      startPage = totalPages - maxVisible + 1;
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i,
    );
  }, [currentPage, totalPages]);

  // --- 2. EARLY RETURNS GO AFTER ALL HOOKS ---
  if (totalPages <= 1) return null;

  return (
    <div className="data-table-pagination">
      {/* Previous Button */}
      <button
        className="pagination-arrow"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        onMouseEnter={() => setLeftHover(true)}
        onMouseLeave={() => setLeftHover(false)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/arrow_down_blue_${
            leftHover ? "medium" : "light"
          }.svg`}
          alt="Previous"
          style={{ transform: "rotate(90deg)" }}
        />
      </button>

      {/* Page Numbers */}
      <div className="pagination-numbers">
        {visiblePages.map((page) => (
          <span
            key={page}
            className={`pagination-number ${
              page === currentPage ? "active" : ""
            }`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className="pagination-arrow"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        onMouseEnter={() => setRightHover(true)}
        onMouseLeave={() => setRightHover(false)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/arrow_down_blue_${
            rightHover ? "medium" : "light"
          }.svg`}
          alt="Next"
          style={{ transform: "rotate(-90deg)" }}
        />
      </button>
    </div>
  );
}

export default DataTablePagination;
